export const getInitialsFromFullName = (fullName?: string): string => {
  if (!fullName || typeof fullName !== 'string') return '';

  return fullName
    .trim()
    .split(' ')
    .filter((name) => name.length > 0)
    .map((name: string) => name.trim().charAt(0).toLocaleUpperCase())
    .join('')
    .slice(0, 2);
};
